import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import { buttonTypes } from 'types/sidebarTypes';
import Images from 'config/assets';

import sidebarButtonStyles from '../../styles';
import sidebarButtonStylesCSS from '../../styles.module.scss';

import styles from './styles';
import SidebarOpenableOptionItem from './components/SidebarOpenableOptionItem';

class SidebarOpenableButton extends PureComponent {
  state = {
    hovered: false
  };

  onMouseEnter = () => this.setState({ hovered: true });

  onMouseLeave = () => this.setState({ hovered: false });

  render() {
    const styleVar = this.props.isActive ? sidebarButtonStylesCSS.active : sidebarButtonStylesCSS.inactive;
    return (
      <div>
        <UTTouchableWithoutFeedback
          onClick={this.props.onClick}
          className={`${sidebarButtonStylesCSS.container} ${styleVar}`}
          containerSetter={this.props.refSetter}
        >
          <div
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
            style={this.props.isActive || this.state.hovered ? styles.activeHeader : styles.header}
          >
            <img alt="" src={this.props.optionImage} style={sidebarButtonStyles.icon} />
            <UTLabel primary style={sidebarButtonStyles.activeText}>
              {this.props.children}
            </UTLabel>
            <img
              alt=""
              src={this.props.isOpen ? Images.sidebarArrowUp : Images.sidebarArrowDown}
              style={styles.arrowIcon}
            />
          </div>
        </UTTouchableWithoutFeedback>
        {this.props.isOpen && (
          <div className={styleVar}>
            {this.props.options.map(option => {
              const onPress = () => this.props.onSuboptionClick(option);
              return (
                <SidebarOpenableOptionItem
                  key={option.optionName}
                  optionName={option.optionName}
                  isActive={option.isActive}
                  linkTo={option.linkTo}
                  onPress={onPress}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

SidebarOpenableButton.propTypes = {
  ...buttonTypes,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      optionName: PropTypes.string.isRequired,
      linkTo: PropTypes.string
    }).isRequired
  ).isRequired,
  refSetter: PropTypes.func.isRequired
};

export default Radium(SidebarOpenableButton);
